import React from 'react'
import { Button } from '@viadelivery/design-system'

const ConfirmModal = ({ onConfirm, title, children, t }) => (
  <div className="modal modal-active fixed w-full h-full top-0 left-0 flex items-center justify-center z-50">
    <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>
    <div className="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
      <div className="modal-content py-4 text-left px-6">
        <div className="flex justify-between items-center pb-3">
          <p className="text-xl font-bold">{title}</p>
        </div>
        {children}
        <div className="flex justify-center pt-2">
          <Button
            onClick={onConfirm}
            className="px-4 py-3 rounded-r bg-green-500 text-white w-1/2"
          >
            {t('common:Confirm')}
          </Button>
        </div>
      </div>
    </div>
  </div>
)

export default ConfirmModal
